import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getApiClient } from '@signalvote/api-client';
import { authService } from '../../services/authService';
import { queryKeys } from '../../lib/queryKeys';
import { useCampaignStore } from '../../stores';
import type { CreateVendorRequest, UpdateVendorRequest } from '@signalvote/shared';

export function useVendors() {
  const { selectedCampaign } = useCampaignStore();

  return useQuery({
    queryKey: queryKeys.vendors.list(),
    queryFn: () => getApiClient().vendors.getVendors(),
    enabled: authService.isAuthenticated() && !!selectedCampaign,
  });
}

export function useCreateVendor() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateVendorRequest) => getApiClient().vendors.createVendor(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.vendors.all });
    },
  });
}

export function useUpdateVendor() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ vendorId, data }: { vendorId: string; data: UpdateVendorRequest }) =>
      getApiClient().vendors.updateVendor(vendorId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.vendors.all });
    },
  });
}

export function useDeleteVendor() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (vendorId: string) => getApiClient().vendors.deleteVendor(vendorId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.vendors.all });
    },
  });
}
